<template>
    <div v-show="visible" class="loading-box">
      <a-spin tip="" />
    </div>
</template>
 
<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
};
</script>
<style scoped lang="less">
.loading-box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(43, 43, 43, 0.2);;
 
    position: absolute;
    top: 0;
    left: 0;
}
</style>